import { FeatureFilter, FilterCondition } from "../types";
import { Feature } from "../../core/geo/types";

function getFeatureIdsToShow(filter: FeatureFilter, featuresToFilter: any) {
    let featuresToShow;
    if (filter.excludeIds.length > 0) {
        featuresToShow = featuresToFilter.filter(
            (feature: any) => !filter.excludeIds.includes(feature.properties.PARENT_ID)
        );
    } else {
        featuresToShow = featuresToFilter;
    }

    if (filter.includeIds.length > 0) {
        featuresToShow = featuresToShow.filter((feature: any) =>
            filter.includeIds.includes(feature.properties.PARENT_ID.toString())
        );
    }
    return featuresToShow.map((feature: any) => feature.properties.FEATURE_ID);
}

function filterFeatures(filters: FeatureFilter[], featuresToFilter: any) {
    return filters.reduce(
        (total: number[], current) => [...total, ...getFeatureIdsToShow(current, featuresToFilter)],
        []
    );
}

export const extractFilterIdsForLayer = (
    layerName: string,
    featureShortName: string,
    features: Feature[],
    filters: FilterCondition[]
) => {
    if (!filters || filters.length <= 0) {
        return features.map((feature: any) => feature.properties.FEATURE_ID);
    }
    const enabledFilters = filters.filter((filter) => filter.enabled);
    if (enabledFilters.length <= 0) {
        return features.map((feature: any) => feature.properties.FEATURE_ID);
    }

    const isIncludeAllLayers = enabledFilters.some((filter) => filter.featureFilters.includeAllLayers);

    const layerFilters = enabledFilters
        .flatMap((filter: any) => filter.featureFilters.filterIds)
        .filter((filter: any) => filter.featureType === featureShortName && filter.enabled);

    if (layerFilters.length > 0) {
        const featuresToShow = filterFeatures(layerFilters, [...features]);
        return featuresToShow.length > 0 ? featuresToShow : null;
    }

    if (isIncludeAllLayers) {
        return features.map((feature: any) => feature.properties.FEATURE_ID);
    }

    return null;
};
